import { useEffect, useState } from 'react';
import { Threshold } from './models';
import { jsonataWithCallback } from '../../expressions';
import { logger } from '../../../utils';
import { THRESHOLD_IDENTIFIER_JSONATA_EXPRESSION } from './constants';

// TODO: Consider order thresholds are specified in, add tests
export const useThreshold = (thresholds: Threshold[], value: any): Threshold | null => {
  const [threshold, setThreshold] = useState<Threshold | null>(null);

  useEffect(() => {
    const jsonataExpression = THRESHOLD_IDENTIFIER_JSONATA_EXPRESSION;
    const findThreshold = async () => {
      try {
        const thresholdToApply = (await jsonataWithCallback(jsonataExpression, {
          thresholds,
          value,
        })) as unknown as Threshold;
        if (thresholdToApply) {
          setThreshold(thresholdToApply);
        }
      } catch (error) {
        logger.error('Error evaluating', jsonataExpression, value, thresholds);
      }
    };
    findThreshold();
  }, [value, thresholds]);

  return threshold;
};
